import React from "react";
import { constants } from "@qgiv/core-js";
import { useSelector } from "react-redux";
import { selectConfig } from "../../redux/slices/configSettingsSlice";
import { selectEnableAbandonedGifts } from "../../redux/slices/donationSettingsSlice";
import DonationFormWrappers from "./DonationFormWrappers";
import { selectCurrentPage } from "../../redux/slices/appSettingsSlice";

/**
 * @returns {React.ReactElement} DonationFormWrappers
 */
const ConnectedDonationFormWrappers = () => {
    const {
        ENUMS: {
            CmsPageStandardizer: { RECURRING_SUMMARY },
        },
    } = constants;
    const enableAbandonedGifts = useSelector(selectEnableAbandonedGifts);
    const config = useSelector(selectConfig);
    const currentPage = useSelector(selectCurrentPage);
    const { isDisplayTypeModal } = config;
    const isRecurringSummary = currentPage === RECURRING_SUMMARY;

    return (
        <DonationFormWrappers
            isDisplayTypeModal={isDisplayTypeModal && !isRecurringSummary}
            enableAbandonedGifts={enableAbandonedGifts}
        />
    );
};

export default ConnectedDonationFormWrappers;
